<script setup>
import HeadRegion from "@/components/HeadHome.vue"
import FootRegion from "@/components/FootRegion.vue"
</script>
<template>
      <HeadRegion></HeadRegion>
      <div class="content_width">
        <section class="slice py-7">
          <div class="container">
          </div>
        </section>   
        <section class="slice slice-lg pt-lg-6 pb-0 pb-lg-6 bg-section-secondary">
          <div id="idc" class="container">
             <div class="row mb-5 justify-content-center text-center">
                <div class="col-lg-6">
                    <span class="badge badge-soft-success badge-pill badge-lg">
                        选择课程
                    </span>
                    <h2 class=" mt-4">C语言系列课程</h2>
                    <div class="mt-2">
                        <p class="lead lh-180">C语言入门课、数据结构与算法、嵌入式开发</p>
                    </div>
                </div>
                   <!-- Card -->
            <div class="row mt-5">
                <div class="col-md-4 cpoint" @click="opencourse('fb1ba2a9e9f44131baaa5dd9cf014a15')">
                    <div class="card">
                        <div class="card-body pb-5">
                            <div class="pt-4 pb-5">
                                <img src="@/assets/img/svg/illustrations/illustration-5.svg" class="img-fluid img-center" style="height: 150px;" alt="Illustration" />
                              </div>
                            <h5 class="h4 lh-130 mb-3">C语言入门课程</h5>
                            <p class="text-muted mb-0 text-justify">C语言在编程语言中属于系统级语言，若希望在系统编程、嵌入式编程有所发展，建议您选择C语言入门课。</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 cpoint" @click="opencourse('ff91025903ae49c2869b9dc1a4e79cc1')">
                    <div class="card">
                        <div class="card-body pb-5">
                            <div class="pt-4 pb-5">
                                <img src="@/assets/img/svg/illustrations/illustration-6.svg" class="img-fluid img-center" style="height: 150px;" alt="Illustration" />
                              </div>
                            <h5 class="h4 lh-130 mb-3">数据结构与算法</h5>
                            <p class="text-muted mb-0 text-justify">数据结构与算法适合计算机以及相关理工专业的本科生学习。对于具有C语言结构化程序设计基础的学生。</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 cpoint" @click="opencourse('44e432dc-e83d-41fc-a414-0d040942266e')">
                    <div class="card">
                        <div class="card-body pb-5">
                            <div class="pt-4 pb-5">
                              <img src="@/assets/img/svg/illustrations/illustration-7.svg" class="img-fluid img-center" style="height: 150px;" alt="Illustration" />
                            </div>
                            <h5 class="h4 lh-130 mb-3">嵌入式开发</h5>
                            <p class="text-muted mb-0 text-justify">嵌入式实时操作系统(RTOS)、各种RTOS、各种嵌入式操作系统、中断、硬件和时钟、嵌入式Linux。</p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
          </div>
        </section>

        <!--Python课程-->
        <section class="slice slice-lg">
          <div id="idpython" class="container">
            <div class="row mb-5 justify-content-center text-center">
              <div class="col-lg-12">
                    <span class="badge badge-soft-success badge-pill badge-lg">
                        选择课程
                    </span>
                    <h2 class=" mt-4">Python系列课程</h2>
                    <div class="mt-2">
                        <p class="lead lh-180">办公自动化、数据可视化、人工智能</p>
                    </div>
                   <!-- Card -->
                   <div class="row mt-5">
                        <el-table
                          :data="tableData">
                          <el-table-column
                            prop="name"
                            label="课程名称"
                            min-width="120">
                          </el-table-column>
                          <el-table-column
                            prop="describe"
                            label="课程描述"
                            min-width="180">
                          </el-table-column>
                          <el-table-column
                            prop="studytime"
                            width="100"
                            label="学习周期">
                          </el-table-column>
                          <el-table-column
                            prop="apply"
                            label="能力要求">
                          </el-table-column>
                          <el-table-column label="操作">
                              <template #default="scope">
                                <el-button
                                  size="mini"
                                  type="primary"
                                  @click="opencourse(scope.row.guid)">进入课程</el-button>
                              </template>
                        </el-table-column>
                        </el-table>
                   </div>
              </div>
            </div>
          </div>
        </section>

        <!--Java课程-->
        <section class="slice slice-lg pt-lg-6 pb-0 pb-lg-6 bg-section-secondary">
          <a href="#javacourse"></a>
          <div id="idjava" class="container">
            <div class="row mb-5 justify-content-center text-center">
              <div class="col-lg-12">
                    <span class="badge badge-soft-success badge-pill badge-lg">
                        选择课程
                    </span>
                    <h2 class=" mt-4">Java语言</h2>
                    <div class="mt-2">
                        <p class="lead lh-180">每天都是“干货满满”，让你学到High，六个月在家也能“脱胎换骨”</p>
                    </div>
                   <div class="row mt-5">
                    <div class="block">
                        <el-timeline>
                          <el-timeline-item timestamp="Java编程" placement="top">
                            <el-card>
                              <el-row :gutter="20">
                                <el-col :span="6"><div class="grid-content bg-purplebox" @click="opencourse('9c60e50379024e10ab7a6c5f4944eedb')">Java编程基础</div></el-col>
                            </el-row>
                            </el-card>
                          </el-timeline-item>
                          <el-timeline-item timestamp="WEB开发" placement="top">
                            <el-card>
                              <el-row :gutter="20">
                                <el-col :span="6"><div class="grid-content bg-purplebox" @click="opencourse('e83a848c30ef49e2b5fc76a5551b0dfd')">MySQL数据库</div></el-col>
                                <el-col :span="6"><div class="grid-content bg-purplebox" @click="opencourse('9434831bf1434f6c93f3e9a930bb27a3')">网页开发</div></el-col>
                                <el-col :span="6"><div class="grid-content bg-purplebox" @click="opencourse('4bd8e1c3afee4fb4bf25b4300680367a')">脚本技术</div></el-col>
                                <el-col :span="6"><div class="grid-content bg-purplebox">WEB服务器</div></el-col>
                            </el-row>
                             <el-row :gutter="20">
                                <el-col :span="6"><div class="grid-content bg-purplebox">前端开放框架</div></el-col>
                                <el-col :span="6"><div class="grid-content bg-purplebox">阶段案例实战</div></el-col>
                             </el-row>
                            </el-card>
                          </el-timeline-item>
                          <el-timeline-item timestamp="Java开发框架" placement="top">
                            <el-card>
                              <el-row :gutter="20">
                                <el-col :span="6"><div class="grid-content bg-purplebox" @click="opencourse('0f31cc0188f14a639f952c00fa45346d')">服务开发框架Spring</div></el-col>
                                <el-col :span="6"><div class="grid-content bg-purplebox">持久层开发框架MyBatis</div></el-col>
                                <el-col :span="6"><div class="grid-content bg-purplebox">服务快速开发SpringBoot</div></el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="6"><div class="grid-content bg-purplebox">版本控制Gid</div></el-col>
                                <el-col :span="6"><div class="grid-content bg-purplebox">项目构建Maven</div></el-col>
                                <el-col :span="6"><div class="grid-content bg-purplebox">Linux部署WEB项目</div></el-col>
                                <el-col :span="6"><div class="grid-content bg-purplebox">CRM项目</div></el-col>
                            </el-row>

                            </el-card>
                          </el-timeline-item>
                          <el-timeline-item timestamp="中间件&服务框架" placement="top">
                            <el-card>
                              <el-row :gutter="20">
                                  <el-col :span="6"><div class="grid-content bg-purplebox">客户端负载均衡</div></el-col>
                                  <el-col :span="6"><div class="grid-content bg-purplebox">消息中间件RabbitMQ</div></el-col>
                                  <el-col :span="6"><div class="grid-content bg-purplebox">Linux部署WEB项目</div></el-col>
                                  <el-col :span="6"><div class="grid-content bg-purplebox">分布式缓存Redis</div></el-col>
                              </el-row>
                              <el-row :gutter="20">
                                <el-col :span="6"><div class="grid-content bg-purplebox">分布式搜索ElasticSerach</div></el-col>
                                <el-col :span="6"><div class="grid-content bg-purplebox">微服务部署Docker</div></el-col>
                                <el-col :span="6"><div class="grid-content bg-purplebox">项目实战</div></el-col>
                              </el-row>
                            </el-card>
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                    </div>

                </div>
            </div>
          </div>
        </section>
      </div>
   <FootRegion></FootRegion>
</template>
  
<script>
import { getCourseBody,getCourseListWithTag } from '@/api/course'
export default {
  name: 'App',
  data() {
    return {
      id:this.$route.query.id,
      coursedata:'',
      primecourse:'',
      pythonshowon:true,
      pythonshowcloase:false,
      tableData: [{
            studytime: '4周',
            name: 'Python编程入门',
            describe: '快速掌握Python编程技术',
            apply: '具备初中学历，无编程基础',
            guid:'22a18aa0f0ac454abb378192ae429811'
          }, {
            studytime: '6周',
            name: '网络爬虫',
            describe: '剖析算法,代码实现,安装配置,基础语法,抓取策略',
            apply: '具备Python编程能力',
            guid:'87f704b984f146cc81dad23b091e02e7'
          }, {
            studytime: '6周',
            name: '应用Python编程，提高办公效率',
            describe: '批量化、自动化、定制化来解决数据问题',
            apply: '具备Python编程能力',
            guid:'215d9c08-3042-450d-a297-e695c86ad568'
          }, {
            studytime: '6周',
            name: '利用Python进行数据分析',
            describe: '数据处理、数据可视化、数据分析',
            apply: '具备Python编程能力',
            guid:'e4286871a4d147f284ce421cbe5b661a'
          },
          {
            studytime: '20周',
            name: 'TensorFlow深度学习实战',
            describe: '使用Python学习TensorFlow可以快速提升你的人工智能学习曲线',
            apply: '具备Python编程基础和一定的数学基础',
            guid:'e1fedcc1-7f1a-41ae-826b-ae61c8e2a69c'
          }
        ]
    }
  },
  mounted() {
    if (typeof this.id != 'undefined') {
      console.log("id:"+ this.id)
      this.scrollToBox(this.id)
    }
  },
  created() {
   },
  methods: {
    handin()
    {
      this.$router.push('/java')
    },
    tableRowClassName({rowIndex}) {
        if (rowIndex === 1) {
          return 'warning-row';
        } else if (rowIndex === 3) {
          return 'success-row';
        }
        return '';
      },
    showCourseInfo(event) {
      console.log(event)
      this.primecourse[event].tag = '1'
      this.pythonshowon=false,
      this.pythonshowcloase=true

    },
    showBox(event) {
      console.log(event)
      this.primecourse[event].tag = '0'
      this.pythonshowon=true,
      this.pythonshowcloase=false
    },

    opencourse(courseid) {
      this.$router.push("/CourseInfo/" + courseid)
    },
      // 获取课程
      async getCourseBodyAPI(){
            const  res  = await getCourseBody({"id":this.id})
            this.coursedata = res
            console.log(res)
            this.roleForm = {
                userid:this.userId,
                id:res.sguid,
                name:res.sname,
                issueDate:res.ddatetime,
                price:res.dprice,
                sealprice:res.dsaleprice,
                brief:res.stextbrief,
                coursecount:res.nallcount,
                photo:res.sphoto
            }
            this.roleForm.userid=this.userId;
          },
    // 获取课程
    async getCourseWithTagAPI(coursetag){
      const  res  = await getCourseListWithTag({"courseTag":coursetag})
      this.primecourse = res
      for( var i = 0; i < this.primecourse.length; i++ ) {
        this.primecourse[i].tag = '0'
      }
      console.log(res)
    },

    getphoto(obj) {
      console.log(obj.photo)
      return "http://www.milihua.com/" + obj.photo
    },
    scrollToBox(item) {
      const element = document.getElementById(item);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
   },
 
 }
</script>
<style scoped>
@import "@/styles/quick-website.css";
  .cpoint {
            cursor: pointer;
        }
 .el-row {
    margin-bottom: 20px;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purplebox {
    border: 1px solid #fafafa;
    background: #fafafa;
    line-height: 45px;
    font-size: 18px;
    cursor: pointer;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 45px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

 </style>


